import React, { useState, useEffect } from 'react';

import { Content } from './styles';

const Container: React.FC = ({ children }) => {
  const [minH, setMinH] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      const { innerHeight: height } = window;
      if (height) {
        setMinH(height);
      }
    }, 1000);
  }, []);

  return (
    <Content minH={minH}>
      <>{children}</>
    </Content>
  );
};

export default Container;
